import { styled } from '@mui/material/styles';
import AddIcon from '@mui/icons-material/Add';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import { useTranslation } from '@hooks';
import { PhoneFrame, BrandAvatar } from './styles';
import { toHandle, truncate } from './utils';
import { TtHeartIcon, TtCommentIcon, TtBookmarkIcon, TtShareIcon } from './PlatformIcons';
import MediaSlide from './MediaSlide';

const TT_FONT = '-apple-system, BlinkMacSystemFont, "TikTok Sans", "Helvetica Neue", sans-serif';
const TRUNCATE_AT = 90;

const Card = styled(PhoneFrame)({
    fontFamily: TT_FONT,
    backgroundColor: '#000',
    color: '#fff',
    position: 'relative',
});

const Stage = styled('div')({ position: 'relative', width: '100%' });

const RightRail = styled('div')({
    position: 'absolute',
    right: 8,
    bottom: 80,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 16,
    color: '#fff',
});

const RailItem = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 2,
    fontSize: 11,
    fontWeight: 600,
    textShadow: '0 1px 2px rgba(0, 0, 0, 0.5)',
    '& svg': { fontSize: 28, filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.5))' },
});

const RailAvatarWrap = styled('div')({ position: 'relative' });

const PlusBadge = styled('div')({
    position: 'absolute',
    bottom: -6,
    left: '50%',
    transform: 'translateX(-50%)',
    width: 18,
    height: 18,
    borderRadius: '50%',
    background: '#fe2c55',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': { fontSize: 14 },
});

const BottomOverlay = styled('div')({
    position: 'absolute',
    left: 12,
    right: 64,
    bottom: 12,
    color: '#fff',
    textShadow: '0 1px 2px rgba(0, 0, 0, 0.55)',
});

const Username = styled('div')({ fontWeight: 700, fontSize: 15, marginBottom: 4 });

const Caption = styled('div')({
    fontSize: 14,
    lineHeight: '18px',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
});

const SoundRow = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    marginTop: 8,
    fontSize: 13,
    '& svg': { fontSize: 14 },
});

const PlatformCardTikTok = ({ pageName, handle: realHandle, locationLogo, message, media }) => {
    const { t } = useTranslation();
    const handle = realHandle || toHandle(pageName, 24);
    const { shown, truncated } = truncate(message, TRUNCATE_AT);
    const caption = truncated ? `${shown} ${t('SocialPosts.preview.more')}` : shown;

    return (
        <Card>
            <Stage>
                <MediaSlide media={media} aspectRatio="9 / 16" dark />
                <RightRail>
                    <RailItem>
                        <RailAvatarWrap>
                            <BrandAvatar
                                name={pageName}
                                image={locationLogo}
                                size={40}
                                color="#fe2c55"
                                style={{ border: '2px solid #fff' }}
                            />
                            <PlusBadge>
                                <AddIcon />
                            </PlusBadge>
                        </RailAvatarWrap>
                    </RailItem>
                    <RailItem>
                        <TtHeartIcon />
                        <span>0</span>
                    </RailItem>
                    <RailItem>
                        <TtCommentIcon />
                        <span>0</span>
                    </RailItem>
                    <RailItem>
                        <TtBookmarkIcon />
                        <span>0</span>
                    </RailItem>
                    <RailItem>
                        <TtShareIcon />
                        <span>0</span>
                    </RailItem>
                </RightRail>
                <BottomOverlay>
                    <Username>@{handle}</Username>
                    {message && <Caption>{caption}</Caption>}
                    <SoundRow>
                        <MusicNoteIcon />
                        <span>{t('SocialPosts.preview.tiktokSound')}</span>
                    </SoundRow>
                </BottomOverlay>
            </Stage>
        </Card>
    );
};

export default PlatformCardTikTok;
